import React from 'react';
import { connect } from 'react-redux';
import {
  colorModeActions,
  colorModeSelectors,
} from '../../redux/modules/colorMode';
import { featuresSelectors } from '../../redux/modules/features';
import { RootState } from '../../redux/rootReducer';
import DarkModeSwitch, { DarkModeSwitchOwnProps } from './DarkModeSwitch';

export type DarkModeSwitchContainerStateProps = Pick<
  DarkModeSwitchOwnProps,
  'colorMode'
> & {
  fountainLifePowerUserEnabled: boolean;
};

export type DarkModeSwitchContainerDispatchProps = Pick<
  DarkModeSwitchOwnProps,
  'setColorMode'
>;

export type DarkModeSwitchContainerProps = DarkModeSwitchContainerStateProps &
  DarkModeSwitchContainerDispatchProps;

export const DarkModeSwitchContainer: React.FC<
  DarkModeSwitchContainerProps
> = ({ fountainLifePowerUserEnabled, ...darkModeSwitchProps }) => {
  if (!fountainLifePowerUserEnabled) {
    return null;
  }

  return <DarkModeSwitch {...darkModeSwitchProps} />;
};

const mapStateToProps = (
  state: RootState,
): DarkModeSwitchContainerStateProps => ({
  colorMode: colorModeSelectors.selectColorMode(state),
  fountainLifePowerUserEnabled:
    featuresSelectors.selectFeatures(state).fountainLifePowerUser === true,
});

const mapDispatchToProps: DarkModeSwitchContainerDispatchProps = {
  setColorMode: colorModeActions.setColorMode,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DarkModeSwitchContainer);
